'use client'
import { ComponentType, FC, PropsWithChildren } from 'react'
import { AppLayout } from '@/root/modules/tuuleliinid'
import { BookingContainer } from '@/root/components/tuuleliinid'
import { Banner } from '@/root/ui/tuuleliinid'
import { useGetTranslations, useReservation } from '@/root/shared-hooks'
import { useAppConfig } from '@/root/shared-hooks/appConfig/useAppConfig'
import { Loader } from '@/root/ui/shared'

interface RefundResultPageProps {
  /** The page frame. The TL header and footer by default; the trial theme passes its unbranded one. */
  Layout?: ComponentType<PropsWithChildren>
}

export const RefundResultPage: FC<RefundResultPageProps> = ({ Layout = AppLayout }) => {
  const { getTranslation } = useGetTranslations()
  const { reservation } = useReservation({ revalidate: true })
  const { formatMoney } = useAppConfig()

  if (!reservation) {
    return (
      <Layout>
        <BookingContainer>
          <div className="flex justify-center py-40">
            <Loader />
          </div>
        </BookingContainer>
      </Layout>
    )
  }

  const { paymentInfo } = reservation
  const totalRefundAmount = paymentInfo.refundOffers?.at(-1)?.totalRefundAmount ?? 0

  return (
    <Layout>
      <BookingContainer>
        <div className="my-10">
          <Banner
            body={getTranslation('ticketWasRefund', {
              reservationId: reservation?.reservationId,
            })}
            variant="success"
            className="mb-10"
          />
          <div className="rounded-xl bg-white p-4">
            <p
              className="text-neutral-dark"
              dangerouslySetInnerHTML={{
                __html: getTranslation('ticketWasRefundTipMaritime', {
                  refundAmount: `<strong class="text-black">${formatMoney(totalRefundAmount)}</strong>`,
                }),
              }}
            />
            <p className="text-neutral-dark border-primary-base mt-10 border-t pt-10">{getTranslation('mayClose')}</p>
          </div>
        </div>
      </BookingContainer>
    </Layout>
  )
}
